// Highlight every `[N]` cell marker inside a logbook line. Stored text
// uses the brackets so the render can locate the number unambiguously
// (no false positives on card stats or names containing digits); the
// brackets are stripped from display and from copy-to-clipboard.
export function renderLogTextWithCells(text) {
  if (!text) return text;
  const matches = [...text.matchAll(/\[(\d+)\]/g)];
  if (matches.length === 0) return text;
  const out = [];
  let last = 0;
  matches.forEach((m, i) => {
    if (m.index > last) out.push(text.slice(last, m.index));
    out.push(
      <span
        key={`c${i}`}
        className="rounded font-semibold tabular-nums"
        style={{
          color: '#f0c050',
          background: 'rgba(212, 168, 67, 0.10)',
          border: '1px solid rgba(212, 168, 67, 0.28)',
          padding: '0 0.3cqw',
          marginInline: '0.1cqw',
        }}
      >
        {m[1]}
      </span>
    );
    last = m.index + m[0].length;
  });
  if (last < text.length) out.push(text.slice(last));
  return out;
}

const LOG_CELL_BRACKET_REGEX = /\[(\d+)\]/g;
export function stripLogCellBrackets(text) {
  return text ? text.replace(LOG_CELL_BRACKET_REGEX, '$1') : text;
}
